import { supabase } from '@/lib/supabase';
import { Tables } from '@/types/database.types';
import { CustomQueryOptions } from '@/types/query';
import { useQuery } from '@tanstack/react-query';
import {
  getHourlyUsageLogs,
  getUsageLogs,
  getUsageLogsByDuringTime,
  getUsageLogsByModelAndTime,
} from '.';
import {
  GetUsageLogsByDuringTimeParams,
  GetUsageLogsByModelAndTimeParams,
  HourlyUsageLogs,
  UsageLogsByModelAndTime,
} from './type';

const keyname = 'usage-logs';

export const useGetUsageLogs = (
  option?: CustomQueryOptions<Tables<'usage_logs'>[]>
) => {
  return useQuery({
    queryKey: [keyname],
    queryFn: getUsageLogs,
    ...option,
  });
};

export const useGetUsageLogsByDuringTime = (
  params: GetUsageLogsByDuringTimeParams,
  option?: CustomQueryOptions<Tables<'usage_logs'>[]>
) => {
  return useQuery({
    queryKey: [keyname, 'during-time', params],
    queryFn: async () => {
      return getUsageLogsByDuringTime(params);
    },
    ...option,
  });
};

export const useGetHourlyUsageLogs = (
  params: GetUsageLogsByDuringTimeParams,
  option?: CustomQueryOptions<HourlyUsageLogs>
) => {
  return useQuery({
    queryKey: [keyname, 'hour', params],
    queryFn: async () => {
      return getHourlyUsageLogs(params);
    },
    ...option,
  });
};

export const useGetUsageLogsByModelAndTime = (
  params: GetUsageLogsByModelAndTimeParams,
  option?: CustomQueryOptions<UsageLogsByModelAndTime>
) => {
  return useQuery({
    queryKey: [keyname, 'model-time', params],
    queryFn: async () => {
      return getUsageLogsByModelAndTime(params);
    },
    ...option,
  });
};
